<template>
  <div
    class="backdrop"
    @click.self="$emit('close')"
  >
    <div
      class="modal"
      :class="{like: theme === 'like'}"
    >
      <h1>{{ title }}</h1>
      <p>{{ text }}</p>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: ['title', 'text', 'theme']
}
</script>

<style>
    .backdrop {
        top: 0;
        position: fixed;
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
    }
    .modal {
        border-radius: 10px;
        max-width: 400px;
        background: #fff;
        padding: .5em;
    }
    .modal.like {
        background: crimson;
        color: white;
    }
</style>
